import { render, staticRenderFns } from "./detection-category-chinese-selector.vue?vue&type=template&id=55967c03&"
import script from "./detection-category-chinese-selector.vue?vue&type=script&lang=js&"
export * from "./detection-category-chinese-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports